import {
  recoverToLogin,
  shouldRecoverFromApi,
} from '@/lib/sessionRecovery';

const apiBase = import.meta.env.VITE_API_URL ?? '';

export function apiUrl(path: string): string {
  return `${apiBase}${path}`;
}

export type ApiError = {
  error: string;
  message: string;
};

export async function apiRequest<T>(
  path: string,
  options: RequestInit = {},
  token?: string | null,
): Promise<T> {
  const headers = new Headers(options.headers);
  headers.set('Content-Type', 'application/json');

  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  let response: Response;

  try {
    response = await fetch(apiUrl(path), {
      ...options,
      headers,
    });
  } catch (error) {
    throw error instanceof Error ? error : new Error('Нет связи с сервером');
  }

  let data: T & ApiError;
  try {
    data = (await response.json()) as T & ApiError;
  } catch {
    throw new Error('Не удалось прочитать ответ сервера');
  }

  if (!response.ok) {
    if (shouldRecoverFromApi(response, data.error, Boolean(token))) {
      recoverToLogin(data);
    }

    const message =
      data.error === 'invalid_token' || data.error === 'unauthorized'
        ? 'Сессия истекла — войдите снова'
        : (data.message ?? 'Ошибка запроса');
    throw new Error(message);
  }

  return data;
}

export * from '@/types/api';
